<template>
    <div class="flex flex-col sm:flex-row justify-between">
        <div
            class="rounded connect-card flex flex-col bg-white px-5 py-10 items-center import-card-shadow w-full sm:w-[49%] mt-10 sm:mt-0"
        >
            <ExternalLink :color="color.hex" class="mt-4 mb-2.5" />
            <div class="flex flex-col mt-10 items-center">
                <p
                    class="text-body-5 font-medium text-default-1 mb-0.5 text-center"
                >
                    External Link
                </p>
                <p
                    class="text-body-6 font-normal text-default-1 mt-3 w-full text-center sm:w-[80%]"
                >
                    Share a link to an external resource and allow your org to
                    access it from the platform.
                </p>
                <CoreButton
                    @click="router.push('/resources/create/external-link')"
                    button-type="secondary"
                    label="Add external link"
                    class="mt-6"
                />
            </div>
        </div>
        <div
            class="rounded connect-card flex flex-col bg-white px-5 py-10 items-center import-card-shadow w-full sm:w-[49%] mt-10 sm:mt-0"
        >
            <PageResource :color="color.hex" class="mt-4 mb-2.5" />
            <div class="flex flex-col mt-10 items-center">
                <p
                    class="text-body-5 font-medium text-default-1 mb-0.5 text-center"
                >
                    Page Type Resource
                </p>
                <p
                    class="text-body-6 font-normal text-default-1 mt-3 text-center w-full sm:w-[80%]"
                >
                    Create your own resource by uploading a picture and coming
                    up with your own title and description.
                </p>
                <CoreButton
                    button-type="secondary"
                    label="Create resource"
                    class="mt-6"
                    @click="router.push('/resources/create/page')"
                />
            </div>
        </div>
    </div>
</template>
<script setup>
import CoreButton from "@/components/core/Button.vue";
import { useTheme } from "@/stores/ThemeStore";
import { useRouter } from "vue-router/dist/vue-router.node.mjs";
import ExternalLink from "@/components/icons/ExternalLink.vue";
import PageResource from "@/components/icons/PageResource.vue";

const router = useRouter();

const themeStore = useTheme();
const { color } = themeStore;
</script>
